<script setup lang="ts">
import type { SurveyAnswerItem } from '../model/interfaces'

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'

import { SURVEY_EMPTY_CELL } from '../model/survey-options'

defineOptions({
  name: 'SurveyAnswers',
})

defineProps<{
  answers: SurveyAnswerItem[]
}>()

const emptyCell = SURVEY_EMPTY_CELL
</script>

<template>
  <div class="survey-answers">
    <AppText
      v-if="!answers.length"
      name="body2"
      color="slate-500"
      class="survey-answers__empty"
    >
      No answers yet.
    </AppText>

    <AppTable
      v-else
      :paginated="false"
    >
      <template #head>
        <AppTr>
          <AppTh class="survey-answers__text-cell">
            <AppText
              name="body2-medium"
              color="slate-900"
            >
              Question
            </AppText>
          </AppTh>
          <AppTh class="survey-answers__text-cell">
            <AppText
              name="body2-medium"
              color="slate-900"
            >
              Answer
            </AppText>
          </AppTh>
          <AppTh>
            <AppText
              name="body2-medium"
              color="slate-900"
            >
              Comment
            </AppText>
          </AppTh>
        </AppTr>
      </template>
      <template #body>
        <AppTr
          v-for="(answer, index) in answers"
          :key="index"
        >
          <AppTd class="medium survey-answers__text-cell">
            <AppText
              name="body2"
              color="slate-900"
            >
              {{ answer.question }}
            </AppText>
          </AppTd>
          <AppTd class="medium survey-answers__text-cell">
            <AppText
              name="body2"
              color="slate-900"
            >
              {{ answer.answer ?? emptyCell }}
            </AppText>
          </AppTd>
          <AppTd class="medium">
            <AppText
              name="body2"
              color="slate-900"
            >
              {{ answer.comment || emptyCell }}
            </AppText>
          </AppTd>
        </AppTr>
      </template>
    </AppTable>
  </div>
</template>

<style scoped lang="scss" src="./SurveyAnswers.scss" />
